import { render } from "./SendExerciseModal.vue?vue&type=template&id=53d9e1b0"
import script from "./SendExerciseModal.vue?vue&type=script&lang=js"
export * from "./SendExerciseModal.vue?vue&type=script&lang=js"

import "./SendExerciseModal.vue?vue&type=style&index=0&id=53d9e1b0&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__